<template><section><h2>基本使用</h2>
<block-demo tip="" source="const { Chart, Wave } = qcharts
const chart = new Chart({ container: &#39;#app&#39; })
const wave = new Wave({
  animation: {
    duration: 500
  },
  radius: 200,
  percent: 65,
  // 格式化文本
  formatter: per =&gt; {
    return &#39;总占比：&#39; + per + &#39;%&#39;
  }
})
// 波浪颜色
wave.style(&#39;wave&#39;, {
  fillColor: &#39;#1890ff&#39;,
  strokeColor: &#39;#1477d4&#39;
})
// 背景图形颜色
wave.style(&#39;shape&#39;, {
  fillColor: &#39;#d3eaff&#39;
})
// 文字颜色
wave.style(&#39;text&#39;, {
  fillColor: &#39;#fff&#39;
})
chart.append(wave)
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> { Chart, Wave } = qcharts
<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({ <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span> })
<span class="hljs-keyword">const</span> wave = <span class="hljs-keyword">new</span> Wave({
  <span class="hljs-attr">animation</span>: {
    <span class="hljs-attr">duration</span>: <span class="hljs-number">500</span>
  },
  <span class="hljs-attr">radius</span>: <span class="hljs-number">200</span>,
  <span class="hljs-attr">percent</span>: <span class="hljs-number">65</span>,
  <span class="hljs-comment">// 格式化文本</span>
  <span class="hljs-attr">formatter</span>: <span class="hljs-function"><span class="hljs-params">per</span> =&gt;</span> {
    <span class="hljs-keyword">return</span> <span class="hljs-string">'总占比：'</span> + per + <span class="hljs-string">'%'</span>
  }
})
<span class="hljs-comment">// 波浪颜色</span>
wave.style(<span class="hljs-string">'wave'</span>, {
  <span class="hljs-attr">fillColor</span>: <span class="hljs-string">'#1890ff'</span>,
  <span class="hljs-attr">strokeColor</span>: <span class="hljs-string">'#1477d4'</span>
})
<span class="hljs-comment">// 背景图形颜色</span>
wave.style(<span class="hljs-string">'shape'</span>, {
  <span class="hljs-attr">fillColor</span>: <span class="hljs-string">'#d3eaff'</span>
})
<span class="hljs-comment">// 文字颜色</span>
wave.style(<span class="hljs-string">'text'</span>, {
  <span class="hljs-attr">fillColor</span>: <span class="hljs-string">'#fff'</span>
})
chart.append(wave)
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>